import Icon from '../components/Icon.vue'

Icon.register({
  podcast: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M267.4 488.6C262.3 507.6 242.9 512 224 512 205.1 512 185.7 507.6 180.6 488.6 172.9 460.1 160 388.9 160 355.8 160 320.6 191.1 312 224 312S288 320.6 288 355.8C288 388.7 275.1 459.9 267.4 488.6zM156.9 288.6C138.2 270.2 126.9 244.4 128.1 216 130.1 166.2 170.5 126 220.2 124.1 274.9 122 320 165.8 320 220 320 246.8 308.9 271.1 291.1 288.6 288.5 291.2 288.7 295.5 291.8 297.7 301.1 304.5 308.2 313.1 313 323.1 314.7 326.8 319.5 327.8 322.4 325 351.3 297.9 369 259.2 368 216.4 366.1 140.2 304.4 78.2 228.2 76.1 146.9 73.8 80 139.2 80 220 80 261.4 97.5 298.7 125.5 325 128.5 327.8 133.3 326.8 135 323.1 139.8 313.1 146.9 304.5 156.2 297.7 159.3 295.5 159.5 291.2 156.9 288.6zM224 0C100.2 0 0 100.2 0 224 0 314 52.6 389.6 125.7 425.4 130.1 427.5 135 423.9 134.3 419.1 131.9 403.6 129.9 388.2 128.9 374.8 128.7 372.9 127.7 371.3 126.2 370.2 78.8 338.4 47.6 284.2 48 222.9 48.6 126.7 127.3 48.3 223.5 48 320.8 47.7 400 126.8 400 224 400 285.9 367.8 340.5 319.4 371.9 318.4 385.9 316.3 402.5 313.7 419.1 313 423.9 317.9 427.5 322.3 425.4 395.2 389.7 448 314.2 448 224 448 100.2 347.8 0 224 0zM224 160C188.7 160 160 188.7 160 224S188.7 288 224 288 288 259.3 288 224 259.3 160 224 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/podcast.js
// module id = 0qLy
// module chunks = 144